export const routes = {
	home: '/',
	history: '/history',
	people: '/people',
	settings: '/settings',
}
